import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Input,
} from "@/components";
import { RequiredLabel } from "@/components/ui/required-label";
import { getPanelBrandSlug } from "@/config/config";
import { useI18n } from "@/context/i18n";

import { TProductFormData } from "../../products.schema";

const EXTERNAL_PRODUCT_ID_INPUT_ID = "product-external-product-id";

export interface ISoulhubExternalProductIdFieldProps {
  form: UseFormReturn<TProductFormData>;
}

export const SoulhubExternalProductIdField: React.FC<
  ISoulhubExternalProductIdFieldProps
> = ({ form }) => {
  const { t } = useI18n();

  if (getPanelBrandSlug() !== "soulhub") {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={"external_product_id" as never}
      render={({ field }) => (
        <FormItem>
          <RequiredLabel
            htmlFor={EXTERNAL_PRODUCT_ID_INPUT_ID}
            required={false}
          >
            {t("products.form.fields.external_product_id")}
          </RequiredLabel>
          <FormControl>
            <Input
              id={EXTERNAL_PRODUCT_ID_INPUT_ID}
              className="w-full"
              placeholder={t(
                "products.form.fields.external_product_id_placeholder",
              )}
              {...field}
              value={(field.value as string | undefined | null) ?? ""}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
